import React from 'react';

export const ExternalLink = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="external-link">
      <path id="Vector" d="M18 13V17C18 18.0609 17.5786 19.0783 16.8284 19.8284C16.0783 20.5786 15.0609 21 14 21H3V6H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path id="Vector_2" d="M15 3H21V9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path id="Vector_3" d="M10 14L21 3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);
